export function isNumericString(num) {
    return !Number.isNaN(num)
}

export function toInteger(num) {
    if (!isNumericString(num)) return
    return Number(num)
}

export function toSingleValue(val) {
    return Array.isArray(val) ? val[val.length - 1] : val
}

export function toSingleValueInteger(num) {
    return toInteger(toSingleValue(num))
}
